<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Crear nuevo permiso / {{ item.name }}</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="CREATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid max-w-screen-md vstack gap-3">
                    <div>
                        <label class="input-title">Nombre</label>
                        <input type="text" class="form-control form-control-sm" v-model="data.name" :class="errors.name ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.name" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <label class="input-title">Ruta</label>
                        <input type="text" class="form-control form-control-sm" v-model="data.route" :class="errors.route ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.route" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <label class="input-title">Icono</label>
                        <input type="text" class="form-control form-control-sm" v-model="data.icon" :class="errors.icon ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.icon" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Visible en el menu</small>
                        <v-select v-model="data.view"
                            :items="views"
                            hide-details
                            class="form-control form-control-sm"
                            :class="errors.view ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.view" :key="index">{{ error }}</small>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            item: { name: '' },
            data: {
                view: 0
            },
            errors: {},
            count: 0,
            id: this.$route.params.id,
            views: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/permissions/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.item = resp.data
                })
                .catch((err) => {
                    vue.$swal({ toast: true, icon: 'error', title: err.response.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        CREATE: function () {
            let vue = this
            vue.count++
            if (vue.count == 1) {
                vue.errors = {}
                vue.data.permission_id = vue.id
                axios({ url: '/permission/items', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'PermissionIndex', query: { selected: vue.id } })
                    })
                    .catch((err) => {
                        if (err.response.status === 422) {
                            vue.errors = err.response.data
                        } else if (err.response.status === 402) {
                            vue.$swal({ toast: true, icon: 'error', title: err.response.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
}
</script>